module.exports = __webpack_public_path__ + "img/rightside_300.8be19252.png";